import { render } from "./dashboardCollaboratore.vue?vue&type=template&id=1dc29e79&ts=true"
import script from "./dashboardCollaboratore.vue?vue&type=script&lang=ts"
export * from "./dashboardCollaboratore.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__